import { categories } from '@/configs/translates.config'
export default {
	'add-new-category': `Add new ${categories.en.singular}`,
	category: categories.en.singular,
	'the-category': `the ${categories.en.singular}?`,
	attributes: 'Attributes'
}